import { Input } from "@frui.ts/bootstrap";
import { observer } from "mobx-react-lite";
import React from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import type RegionCreateViewModel from "viewModels/timeCharges/distributorEnums/regions/regionCreateViewModel";
import type RegionDetailViewModel from "viewModels/timeCharges/distributorEnums/regions/regionDetailViewModel";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";

export interface RegionFormProps {
  vm: RegionCreateViewModel | RegionDetailViewModel;
  children?: React.ReactNode;
}

const RegionForm = observer((props: RegionFormProps) => {
  const { vm, children } = props;
  const disabled = !vm.isEditable;

  return (
    <>
      <Form.Row>
        <FormGroup as={Col} md="6" target={vm.item} property="name">
          <FormLabel>{vm.translateAttribute("name")}</FormLabel>
          <Input disabled={disabled} />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} md="6" target={vm.item} property="nutsCode">
          <FormLabel>{vm.translateAttribute("nutsCode")}</FormLabel>
          <Input disabled={disabled} />
        </FormGroup>
        <FormGroup as={Col} md="6" target={vm.item} property="licensePlateLetter">
          <FormLabel>{vm.translateAttribute("licensePlateLetter")}</FormLabel>
          <Input disabled={disabled} />
        </FormGroup>
      </Form.Row>
      {children}
    </>
  );
});

export default RegionForm;
